export default function isIndex(value) {
  const reIsUint = /^(?:0|[1-9]\d*)$/;
  return typeof value === 'number' || reIsUint.test(value);
}
